<template>
    <div class="card-body p-0">
        <ul class="nav nav-tabs px-0 border-0" id="loginTab" role="tablist">
            <li class="nav-item w-50">
                <a class="nav-link py-3 text-center font-poppins font-weight-medium font-size-18 color-dark-blue left" :href="route('nl.employeedashboard.login')">
                    <img src="/img/login/icon-employee.svg"> {{ Lang.get('employerdashboard::pages/auth/login.for_employees') }}
                </a>
            </li>

            <li class="nav-item w-50">
                <a class="border-white nav-link py-3 text-center font-poppins font-weight-medium font-size-18 color-dark-blue right active" id="employer-tab" href="#employer" aria-selected="true">
                    <img src="/img/login/icon-employer.svg"> {{ Lang.get('employerdashboard::pages/auth/login.for_employers') }}

                </a>
            </li>
        </ul>

        <div class="tab-content ml-0" id="loginTabContent">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuthTabPanel"
}
</script>
